export const TIME_CONFIGURATION = {
  PT5S: 'PT5S',
  PT10S: 'PT10S',
  PT15S: 'PT15S',
  PT20S: 'PT20S',
  PT30S: 'PT30S',
  PT45S: 'PT45S',
  PT60S: 'PT60S',
  PT90S: 'PT90S',
  PT120S: 'PT120S'
};

export const SCREENSAVER_SELECT = 'screensaver-select';
export const SCREENSAVER_DETAILS = 'screensaver-details';
export const SCREENSAVER_DASHBOARD = 'screensaver-dashboard';
